import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Services = () => {
	return (
		<section class='services py-5'>
			<div class='container'>
				<h2 class='serv-heading'>
					Our <span>Services</span>
				</h2>
				<div class='row'>
					<article class='col-md-4'>
						<div class='m-3 shadow'>
							<div class='row'>
								<div class='col-sm-4 serv-icon'>
									<div class='d-flex h-100'>
										<div class='mx-auto align-self-center'>
											<FontAwesomeIcon icon='fire' />
										</div>
									</div>
								</div>
								<div class='col-sm-8 p-2'>
									<div class='px-2'>
										<h3>Service</h3>
										<p>
											Lorem ipsum dolor sit amet consectetur
											adipisicing elit cumque id eligendi, enim
											dolorem.
										</p>
									</div>
								</div>
							</div>
						</div>
					</article>
					<article class='col-md-4'>
						<div class='m-3 shadow'>
							<div class='row'>
								<div class='col-sm-4 serv-icon'>
									<div class='d-flex h-100'>
										<div class='mx-auto align-self-center'>
											<FontAwesomeIcon icon='fire' />
										</div>
									</div>
								</div>
								<div class='col-sm-8 p-2'>
									<div class='px-2'>
										<h3>Service</h3>
										<p>
											Lorem ipsum dolor sit amet consectetur
											adipisicing elit cumque id eligendi, enim
											dolorem.
										</p>
									</div>
								</div>
							</div>
						</div>
					</article>
					<article class='col-md-4'>
						<div class='m-3 shadow'>
							<div class='row'>
								<div class='col-sm-4 serv-icon'>
									<div class='d-flex h-100'>
										<div class='mx-auto align-self-center'>
											<FontAwesomeIcon icon='fire' />
										</div>
									</div>
								</div>
								<div class='col-sm-8 p-2'>
									<div class='px-2'>
										<h3>Service</h3>
										<p>
											Lorem ipsum dolor sit amet consectetur
											adipisicing elit cumque id eligendi, enim
											dolorem.
										</p>
									</div>
								</div>
							</div>
						</div>
					</article>
					<article class='col-md-4'>
						<div class='m-3 shadow'>
							<div class='row'>
								<div class='col-sm-4 serv-icon'>
									<div class='d-flex h-100'>
										<div class='mx-auto align-self-center'>
											<FontAwesomeIcon icon='fire' />
										</div>
									</div>
								</div>
								<div class='col-sm-8 p-2'>
									<div class='px-2'>
										<h3>Service</h3>
										<p>
											Lorem ipsum dolor sit amet consectetur
											adipisicing elit cumque id eligendi, enim
											dolorem.
										</p>
									</div>
								</div>
							</div>
						</div>
					</article>
					<article class='col-md-4'>
						<div class='m-3 shadow'>
							<div class='row'>
								<div class='col-sm-4 serv-icon'>
									<div class='d-flex h-100'>
										<div class='mx-auto align-self-center'>
											<FontAwesomeIcon icon='fire' />
										</div>
									</div>
								</div>
								<div class='col-sm-8 p-2'>
									<div class='px-2'>
										<h3>Service</h3>
										<p>
											Lorem ipsum dolor sit amet consectetur
											adipisicing elit cumque id eligendi, enim
											dolorem.
										</p>
									</div>
								</div>
							</div>
						</div>
					</article>
					<article class='col-md-4'>
						<div class='m-3 shadow'>
							<div class='row'>
								<div class='col-sm-4 serv-icon'>
									<div class='d-flex h-100'>
										<div class='mx-auto align-self-center'>
											<FontAwesomeIcon icon='fire' />
										</div>
									</div>
								</div>
								<div class='col-sm-8 p-2'>
									<div class='px-2'>
										<h3>Service</h3>
										<p>
											Lorem ipsum dolor sit amet consectetur
											adipisicing elit cumque id eligendi, enim
											dolorem.
										</p>
									</div>
								</div>
							</div>
						</div>
					</article>
				</div>
			</div>
		</section>
	);
};

export default Services;
